module.exports = __webpack_public_path__ + "static/media/office365.9db81272.png";